(function () {
	"use strict";
	let blockwheelsBlocksLogoCarousel = {
		initAll: function () {

			const elementList = document.querySelectorAll(
				'.wp-block-blockwheels-logo-carousel'
			);

			if (!elementList || elementList.length === 0) {
				return;
			}
			[...elementList].forEach((singleSlide) => {
				const swiperSliderDiv = singleSlide.querySelector(
					'.blockwheels-logo-carousel-container'
				);
				const parsedData 	= swiperSliderDiv.dataset;
				const sliderId 		= parsedData.id;
				const deskItems 	= parseInt(parsedData.desktop);
				const tabItems 		= parseInt(parsedData.tablet);
				const phoneItems 	= parseInt(parsedData.mobile);
				const deskSpace 	= parseInt(parsedData.deskspace);
				const tabSpace 		= parseInt(parsedData.tabspace);
				const phoneSpace 	= parseInt(parsedData.phonespace);
				const autoplay 		= JSON.parse(parsedData.autoplay);
				const autoplayDelay = parseInt(parsedData.autoplaydelay);
				const autoplayDirection = JSON.parse(
					parsedData.autoplaydirection
				);
				const pauseOnHover 	= JSON.parse(parsedData.pauseonhover);
			
				const autoplayOptions = autoplay
					? {
							delay: autoplayDelay,
							reverseDirection: autoplayDirection,
							pauseOnMouseEnter: pauseOnHover,
							disableOnInteraction: false,
					  }
					: false;
			
				const speed 		= parseInt(parsedData.speed);
				const loop 			= JSON.parse(parsedData.loop);
			
				// pagination options
				const showPagination 	= JSON.parse(parsedData.pagination);
				const paginationClass 	= singleSlide.querySelector('.logo-carousel-pagination');
			
				const paginationOptions = showPagination
					? {
							el: paginationClass,
							clickable: showPagination,
					  }
					: false;
			
				// navigation options
				const showNav = JSON.parse(parsedData.navigation);
				const prevNav = singleSlide.querySelector('.logo-carousel-nav-prev');
				const nextNav = singleSlide.querySelector('.logo-carousel-nav-next');
			
				const navigationOptions = showNav
					? {
							nextEl: nextNav,
							prevEl: prevNav,
					  }
					: false;
			
				const slider = new Swiper(`#${sliderId}`, {
					pagination: paginationOptions,
					navigation: navigationOptions,
					slidesPerView: deskItems,
					spaceBetween: deskSpace,
					autoplay: autoplayOptions,
					speed,
					loop,
					breakpoints: {
						320: {
							slidesPerView: phoneItems,
							spaceBetween: phoneSpace,
						},
			
						601: {
							slidesPerView: tabItems,
							spaceBetween: tabSpace,
						},
			
						992: {
							slidesPerView: deskItems,
							spaceBetween: deskSpace,
						},
					},
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockwheelsBlocksLogoCarousel.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockwheelsBlocksLogoCarousel.init);
	} else {
		// The DOM has already been loaded.
		blockwheelsBlocksLogoCarousel.init();
	}
})();